import { Component, OnInit } from "@angular/core";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { SchoolService } from "../../../shared/services/school.service";
import { ReportService } from "../report.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import * as moment from "moment";

@Component({
	selector: "app-hs-school-log",
	templateUrl: "./hs-school-log.component.html",
	styleUrls: ["./hs-school-log.component.css"],
})
export class HsSchoolLogComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private reportService: ReportService,
		private dialogService: DialogService
	) {}

	report = {
		SchoolID: 0,
		DateOptionID: 0,
		startDate: new Date(),
		endDate: new Date(),
		TimeOptionID: 0,
		StartTime: new Date(),
		EndTime: new Date(),
		PeriodID: 0,
		SortBy: "Date",
		SortDirection: "ASC",
		ImageLogo: "",
	};

	DateOptionList: any = [
		{
			ID: 0,
			Desc: "Today",
		},
		{
			ID: 1,
			Desc: "Last Month",
		},
		{
			ID: 2,
			Desc: "Last 2 Months",
		},
		{
			ID: 3,
			Desc: "Last 3 Months",
		},
		{
			ID: 99,
			Desc: "Current School Year",
		},
		{
			ID: -1,
			Desc: "Custom Date Range",
		},
		{
			ID: 12000,
			Desc: "All",
		},
	];

	TimeOptionList: any = [
		{
			ID: 0,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "By Time",
		},
		{
			ID: 2,
			Desc: "By Period",
		},
	];

	PeriodList: any = [];

	SortByList: any = [
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "Date",
			Desc: "Date",
		},
		{
			ID: "Level",
			Desc: "Current Count",
		},
		{
			ID: "Consequence",
			Desc: "Consequence",
		},
	];

	SortDirectionList: any = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	ImageLogoList: any = [];
	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	lstByType = [
		{
			ByTypeDesc: "Name",
		},
		{
			ByTypeDesc: "Academy",
		},
		{
			ByTypeDesc: "Homeroom",
		},
		{
			ByTypeDesc: "Grade",
		},
		{
			ByTypeDesc: "IssueDate",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 452;

	subscription: any;

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadPeriod();
		this.loadLogolist();
	}

	ngOnInit() {
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadPeriod() {
		this.report.PeriodID = 0;
		var result = this.reportService.PeriodGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.PeriodList = response;

				this.report.PeriodID = this.PeriodList[0].PeriodID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 452;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		// strParam += this.report.SchoolID + "|SchoolID"
		var startDate = moment(this.report.startDate).format("MM/DD/YYYY");
		var endDate = moment(this.report.endDate).format("MM/DD/YYYY");
		var startTime = moment(this.report.StartTime).format("HH:mm:00");
		var endTime = moment(this.report.EndTime).format("HH:mm:00");

		strParam += this.report.DateOptionID + "|LastXMonths";
		strParam += "," + startDate + "|StartDate";
		strParam += "," + endDate + "|EndDate";
		strParam += "," + this.report.TimeOptionID + "|TimeOptionID";
		strParam += "," + startTime + "|StartTime";
		strParam += "," + endTime + "|EndTime";
		strParam += "," + this.report.PeriodID + "|PeriodID";
		strParam += "," + this.report.SortBy + "|SortBy";
		strParam += "," + this.report.SortDirection + "|SortDirection";
		strParam += "," + this.report.ImageLogo + "|ImageLogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
